import styled from "@emotion/styled";
import { SUBGRID_TEMPLATE } from "components/Common/LineItemGrid/LineItemGridStyles";

export const MobileModPrice = styled.div(({ theme }) => ({
	color: `${theme.project.colors.fontColors.secondary} !important`,
	fontWeight: "400 !important",
	[theme.breakpoints.up("md")]: {
		display: "none"
	}
}));

export const Wrapper = styled.div<{ isSpecialModification: boolean; hasLineNumber?: boolean }>(
	({ theme, isSpecialModification, hasLineNumber = true }) =>
		!isSpecialModification
			? {
					...SUBGRID_TEMPLATE,
					fontSize: "0.875rem",
					"& > div:first-of-type": {
						display: "flex",
						alignItems: "baseline",
						gap: hasLineNumber ? 12 : 0,
						gridColumn: "span 5", // Modification name column,
						[theme.breakpoints.up("md")]: {
							alignItems: "center"
						}
					},
					"& > div:nth-of-type(2)": {
						...SUBGRID_TEMPLATE,
						gridColumn: "span 2"
					},
					"& > div > div:first-of-type": {
						minWidth: hasLineNumber ? 26 : 0
					},
					"& > div > div:nth-of-type(2)": {
						display: "flex",
						flexWrap: "wrap" as const,
						gap: 8,
						"div:nth-of-type(1)": {
							color: theme.project.colors.fontColors.main,
							fontWeight: 500,
							whiteSpace: "pre-wrap",
							span: {
								...theme.project.typography.body.body2,
								lineHeight: "normal",
								marginLeft: 12
							}
						}
					},
					[theme.breakpoints.down("md")]: {
						gap: 12,
						gridTemplateColumns: "minmax(42px, min-content) auto",
						"& > div:first-of-type": {
							...SUBGRID_TEMPLATE
						},
						"&&&& > div > div:first-of-type": {
							color: theme.project.colors.fontColors.secondary,
							fontWeight: 400,
							gridColumn: "1"
						},
						"&&& > div:nth-of-type(2)": {
							display: "none"
						}
					}
				}
			: {
					display: "flex",
					width: "84%",
					fontSize: "14px",
					"& > div": {
						width: "100%",
						display: "flex",
						justifyContent: "space-between"
					},
					"& > div > div": {
						display: "flex",
						justifyContent: "space-between",
						flexWrap: "wrap" as const,
						gap: 8,
						"div:nth-of-type(1)": {
							color: theme.project.colors.fontColors.main,
							fontWeight: 500,
							whiteSpace: "pre-wrap",
							span: {
								...theme.project.typography.body.body2,
								lineHeight: "normal",
								marginLeft: 12
							}
						}
					}
				}
);
